export default "__VITE_ASSET__nqbvDXLP__"